module.exports = __webpack_public_path__ + "static/img/app-intro2.ca1c4eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app-intro2.png
// module id = wTon
// module chunks = 88